<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import "./assets/font/iconfont.css"

export default {
  name: 'app',
  components: {

  }
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }
#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #999;
  font-size: 12px;
  background: #ececec;
  /*height: 100vh;*/
  margin: 0;
  padding: 0;
}
</style>
